"use strict";

export function feature_js_dataview_filter(el, target) {

    el.on('change', '[js-dataview-filter--extended-checkbox]', function () {
        el.find('[js-dataview-filter--extended]').toggleClass('hidden', !$(this).is(':checked'));
    });
}